import SEO from "../../data/seo";
import FooterFour from "../../layout/footers/footer-four";
import HeaderFour from "../../layout/headers/header-four";
import ContactMain from "./contact";

const ContactUs = () => {
    return (
        <>
            <SEO pageTitle="İletişim" />
            <HeaderFour />
            <div
                className="bg-video"
                style={{ maxWidth: "100%", overflow: "hidden", position: "relative", height: "480px" }}
            >
                <video autoPlay muted loop playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }}>
                    <source src="https://buildgo-react.vercel.app/static/media/banner.b1e80eca5dee07cccccd.mp4" type="video/mp4" />
                </video>
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 1,
                        width: "100%",
                    }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="breadcrumb__area-content" style={{ textAlign: "center" }}>
                                    <h2
                                        style={{
                                            fontWeight: 500,
                                            WebkitTextStrokeWidth: "1px",
                                            WebkitTextStrokeColor: "#FFFFFF",
                                            color: "transparent",
                                            fontSize: "80px",
                                        }}
                                    >
                                        İletişim
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ContactMain />
            <FooterFour />
        </>
    );
};

export default ContactUs;